import { Directive, OnInit, OnDestroy, inject } from '@angular/core';
import { NzTooltipDirective } from 'ng-zorro-antd/tooltip';
import { TooltipAutoCloseService } from 'src/services/tooltip-close.service';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[nz-tooltip][autoCloseOnScroll]',
  standalone: false,
})
export class TooltipAutoCloseDirective implements OnInit, OnDestroy {
  private service = inject(TooltipAutoCloseService);
  private tooltip = inject(NzTooltipDirective);

  public ngOnInit(): void {
    this.service.register(this.tooltip);
  }

  public ngOnDestroy(): void {
    this.service.unregister(this.tooltip);
  }
}